type MarketLink = {
  label: string;
  href: string;
};

export function MexicoMarketSignal({
  eyebrow = "México y Latinoamérica",
  title,
  body,
  links = [],
}: {
  eyebrow?: string;
  title: string;
  body: string;
  links?: MarketLink[];
}) {
  return (
    <section
      className="border-t border-[var(--line-neutral)] bg-[var(--surface-secondary)]"
      aria-label="Relevancia para México"
      data-seo-market="mx"
    >
      <div className="mx-auto max-w-7xl px-6 py-12 sm:py-14">
        <div className="max-w-4xl">
          <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">
            {eyebrow}
          </p>
          <h2 className="mt-3 font-display text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
            {title}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground sm:text-base">{body}</p>
          {links.length > 0 ? (
            <div className="mt-6 flex flex-wrap gap-x-5 gap-y-3 text-sm font-semibold">
              {links.map((link) => (
                <a key={link.href} href={link.href} className="underline underline-offset-4 hover:opacity-80">
                  {link.label}
                </a>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
